export default "__VITE_ASSET__C4a7FmqL__";